module.exports = __webpack_public_path__ + "img/general-meter-gas-meter-md.eb993990.svg";